/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <div :class="{ errormessage: error && error != '' }">
      <label v-if="label" :for="identifier">{{ label }}</label>
      <select
        :id="identifier"
        :name="identifier"
        @change="
          $emit('input', $event.target.value);
          $emit('valueChanged');
        "
        v-model="dropdownValue"
        v-bind="attrs"
      >
        <option :value="defaultvalue" :disabled="defaultdisabled">
          {{ defaultname }}
        </option>
        <option v-for="(option, index) in options" :value="option.key" :key="index">
          {{ option.value }}
        </option>
      </select>
    </div>
    <div class="error">
      <span v-if="error" class="errormessage">{{ error }}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
export default {
  name: "SelectInput",
  computed: {
    dropdownValue() {
      return this.value;
    },
  },
  props: [
    "label",
    "value",
    "identifier",
    "attrs",
    "options",
    "defaultname",
    "defaultvalue",
    "defaultdisabled",
    "error",
  ],
};
</script>

<style lang="scss" scoped>
select {
  padding: 7px;
  width: 100%;
  border: 1px solid #e4e4e4;
}

.error {
  position: absolute;
  right: 0;
  padding-top: 3px;
  font-size: 0.8em;
  color: #d43131;
}

.error span {
  width: 100%;
  text-align: right;
}

.errormessage select {
  border-color: #d43131;
}
</style>
